var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1257_32313)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 17.5H2.5V12.6667C3.16667 12.6667 3.75 12.4549 4.25 12.0312C4.75 11.6076 5 11.0694 5 10.4167C5 9.76389 4.75 9.22569 4.25 8.80208C3.75 8.37847 3.16667 8.16667 2.5 8.16667V3.33333H7.5C7.5 2.75 7.70139 2.25694 8.10417 1.85417C8.50694 1.45139 9 1.25 9.58333 1.25C10.1667 1.25 10.6597 1.45139 11.0625 1.85417C11.4653 2.25694 11.6667 2.75 11.6667 3.33333H16.6667V8.33333C17.25 8.33333 17.7431 8.53472 18.1458 8.9375C18.5486 9.34028 18.75 9.83333 18.75 10.4167C18.75 11 18.5486 11.4931 18.1458 11.8958C17.7431 12.2986 17.25 12.5 16.6667 12.5V17.5H11.8333C11.8333 16.8056 11.6146 16.2153 11.1771 15.7292C10.7396 15.2431 10.2083 15 9.58333 15C8.95833 15 8.42708 15.2431 7.98958 15.7292C7.55208 16.2153 7.33333 16.8056 7.33333 17.5Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1257_32313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannels);
export default __webpack_public_path__ + "static/media/channels.e4003293bf4a1382da536eddf0e3522d.svg";
export { ForwardRef as ReactComponent };